import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/location_new/toronto/banner_toronto.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner hosuton_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <span style={{ color: "#f47a1f", fontWeight: "600" }}>
                Create User-Center Apps Built for a Purpose
              </span>
              <h1>App Development Company Toronto</h1>
              <p className="main_para">
                Turn your app ideas into reality with our top-tier app
                development company in Toronto. Serving other regions in the US,
                we have gained authorization in the Canadian tech market with
                our customer-focused mobile apps. From ideation to research and
                all the way to core development with QA and maintenance, we
                ensure the creation of a full-fledged application. Whether you
                need a native for iOS and Android or a cross-platform app, we
                have diverse resources to facilitate you as per your
                requirements.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Discuss Your Project
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
